export const apiExplorerConstants = {
    GETALL_APIS_REQUEST: "APIS_GETALL_REQUEST",
    GETALL_APIS_SUCCESS: "APIS_GETALL_SUCCESS",
    GETALL_APIS_FAILURE: "APIS_GETALL_FAILURE",

    GET_API_RESULT_REQUEST: "API_RESULT_REQUEST",
    GET_API_RESULT_SUCCESS: "API_RESULT_SUCCESS",
    GET_API_RESULT_FAILURE: "API_RESULT_FAILURE",

    GET_API_DETAILS_REQUEST: "API_DETAILS_REQUEST",
    GET_API_DETAILS_SUCCESS: "API_DETAILS_SUCCESS",
    GET_API_DETAILS_FAILURE: "API_DETAILS_FAILURE",

    GET_API_TOP_CARD_INFO_REQUEST: "GET_API_TOP_CARD_INFO_REQUEST",
    GET_API_TOP_CARD_INFO_SUCCESS: "GET_API_TOP_CARD_INFO_SUCCESS",
    GET_API_TOP_CARD_INFO_FAILURE: "GET_API_TOP_CARD_INFO_FAILURE",

    GET_API_FILTER_REQUEST: "API_FILTER_FETCH_REQUEST",
    GET_API_FILTER_SUCCESS: "API_FILTER_FETCH_SUCCESS",
    GET_API_FILTER_FAILURE: "API_FILTER_FETCH_FAILURE",

    APIEXPLORER_STATUS_UPDATE_REQUEST: "APIEXPLORER_STATUS_UPDATE_REQUEST",
    APIEXPLORER_STATUS_UPDATE_SUCCESS: "APIEXPLORER_STATUS_UPDATE_SUCCESS",
    APIEXPLORER_STATUS_UPDATE_FAILURE: "APIEXPLORER_STATUS_UPDATE_FAILURE",
};